module.exports = __webpack_public_path__ + "static/img/zgjsyh.980bd9da.png";